import { render } from "./Video.vue?vue&type=template&id=4e9d7cc9&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=4e9d7cc9&scoped=true&lang=css"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9d7cc9"]])

export default __exports__